import React from 'react'
import { upper } from '../../data/dates'
import '../sections/FestivalHero.css'
import './PageHero.css'

export default function PageHero({ eyebrow, title, lede, aside }) {
  return (
    <section className='hero-area hero-ethos page-hero' lang='tr'>
      <div className='hero-ethos-bg' style={{ backgroundImage: 'url(images/banner/banner.jpg)' }} aria-hidden='true'></div>
      <div className={`container hero-ethos-row page-hero-row${aside ? '' : ' hero-ethos-row--single'}`}>
        <div className='hero-ethos-text'>
          {eyebrow ? <p className='page-hero-eyebrow'>{eyebrow}</p> : null}
          <h1 className='hero-ethos-title'>
            <span className='hero-ethos-name page-hero-title'>{upper(title)}</span>
          </h1>
          {lede ? <p className='page-hero-lede'>{lede}</p> : null}
        </div>
        {aside ? <div className='page-hero-aside'>{aside}</div> : null}
      </div>
    </section>
  )
}
